import PropTypes from "prop-types";
import React from "react";
import { FieldRow } from "./FieldRow";
import { renderValue } from "./valueRenderers";
import { SectionHeader } from "./SectionHeader";

export const Section = ({ def, attrs }) => (
  <>
    <SectionHeader title={def.title} />
    {def.fields.map((field) => (
      <FieldRow key={field.key} label={field.label} tooltip={field.tooltip}>
        {renderValue(attrs[field.key], field.kind)}
      </FieldRow>
    ))}
  </>
);

Section.propTypes = {
  def: PropTypes.shape({
    title: PropTypes.string.isRequired,
    fields: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        tooltip: PropTypes.string,
        kind: PropTypes.string.isRequired,
      }),
    ).isRequired,
  }).isRequired,
  attrs: PropTypes.shape({}).isRequired,
};

export default Section;
